<!-- breadcrumb -->

<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Ecografias</h4><span class="text-muted mt-1 tx-13 ms-2 mb-0">/
    Inicio</span>
  </div>
  <div class="mb-6 mb-xl-0">
    <div ngbDropdown class="btn-group">

      <div ngbDropdown class="d-inline-block wd-xl-100p">
        <button
          type="button"
          class="btn btn-primary btn-block"
          id="dropdownBasic1"
          ngbDropdownToggle
          >
          Nueva transacción
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <button ngbDropdownItem (click)="rutaCrearOrden()">Orden electrónica con Factura</button>
          <button ngbDropdownItem (click)="rutaCrearOrdenSF()">Orden electrónica sin Factura</button>
          <button ngbDropdownItem (click)="modalSecuenciaFisica(mdlIngresarSecuencia)">Orden Física Con Factura</button>
          <button ngbDropdownItem (click)="modalSecuenciaFisica(mdlIngresarSecuenciaSF)">Orden Física Sin Factura</button>
          <button ngbDropdownItem (click)="rutaCrearOrdenCitaPrevia()">Orden Electrónica (Cita Previa)</button>

        </div>
      </div>

    </div>
  </div>
</div>

</div>

<div class="row">
  <div class="col-md-12 col-xl-12 col-xs-12 col-sm-12">
    <!--div-->
    <div class="card">
      <div class="card-body">
        <div class="main-content-label mg-b-5">
          Filtrar
        </div>
        <!-- <p class="mg-b-20">It is Very Easy to Customize and it uses in your website apllication.</p> -->
        <div class="row row-sm align-items-end">
          <div class="col-lg">
            <label for="">Desde</label>
            <input class="form-control" [(ngModel)]="fechaInicio" min="2023-05-01" type="date">
          </div>
          <div class="col-lg">
            <label for="">Hasta</label>
            <input class="form-control" [(ngModel)]="fechaFin"  min="2023-05-01" type="date">
          </div>
          <div class="col-lg">
            <label for="">Estado</label>
            <ng-select  [searchable]="false"  [(ngModel)]="estadoFiltro"  class="form-control">
              <ng-option value="pendiente">Pendientes</ng-option>
              <ng-option value="atendidas">Atendidas</ng-option>
              <!-- <ng-option value="con-imagenes">Imagenes Doctor</ng-option> -->
            </ng-select>
          </div>
          <div class="col-lg">
            <label for="">Sucursal</label>
            <ng-select class="form-control" [(ngModel)]="idSucursal" (change)="cambiarSucursal($event)">
              @for (suc of _arraySucursales; track suc) {
                <ng-option [value]="suc.COD_SURC">{{suc.DIR_SURC}}</ng-option>
              }
            </ng-select>
          </div>
          <div class="col-lg-auto col-md-3 col-sm-12 filter-action">
            <label class="d-block">&nbsp;</label>
            <button type="button" class="btn btn-dark w-100" (click)="filtrarEcografiasFechas()" [disabled]="filterLoading">
              @if (!filterLoading) {
                Buscar <i class="fe fe-search ms-1"></i>
              } @else {
                <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                Filtrando...
              }
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-12 col-xl-12 col-xs-12 col-sm-12">

    @if (spinnerBoolean) {
      <div class="text-center">
        <div class="spinner-grow" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <br>
        </div>
      }
      <!--div-->
      <div class="card">
        <div class="card-body">
          <div class="table-responsive">




            <table   datatable [dtOptions]="dtOptions"  class="table table-bordered table-striped table-hover dt-ext">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Factura</th>
                  <th>Nº Orden</th>
                  <th>Paciente</th>
                  <th>Celular Paciente</th>
                  <th>Fec. Nacimiento Paciente</th>
                  <th>Cod. Doctor</th>
                  <th>Doctor</th>
                  <th>Sucursal</th>
                  <th>Fecha de registro</th>
                  <th>Tipo</th>
                  <th>Responsable</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                @for (dt of ordenes; track rowIndex; let rowIndex = $index) {
                  <tr>
                    <td>{{rowIndex+1}}</td>
                    <td> {{dt.numeroFacturaOrden}} </td>
                    <td>
                      <div class="text-center">{{ordenes[rowIndex].NUM_ORD}} </div>
                      @if (ordenes[rowIndex].secuenciaOrden !=null &&  ordenes[rowIndex].secuenciaOrden !='null'  &&  ordenes[rowIndex].secuenciaOrden !='') {
                        <div>
                          <div class="text-center"><b>SF:</b> <p class="text-success">{{ordenes[rowIndex].secuenciaOrden}}</p></div>
                        </div>
                      }
                    </td>
                    <td>{{ dt.NOM_CLI }}</td>
                    <td>{{ dt.TEL_CLI }} </td>
                    <td>@if (ordenes[rowIndex].FEC_CLI !== null) {
                      <div>
                        <div class="text-center">{{ordenes[rowIndex].FEC_CLI}}</div>
                      </div>
                    }
                    @if (ordenes[rowIndex].FEC_CLI ==null || ordenes[rowIndex].FEC_CLI =='' || ordenes[rowIndex].FEC_CLI =='null') {
                      <div>
                        <div class="text-center text-danger">NO ESTABLECIDO</div>
                      </div>
                    }</td>
                    <td>{{ dt.CODN_DOC }}</td>
                    <td>{{ dt.NOM_DOC }}</td>
                    <td>{{ dt.DIR_SURC }}</td>
                    <td>{{ dt.fecha }}</td>
                    <td>@if (ordenes[rowIndex].tipo === 'WEB') {
                      <div>
                        <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
                      </div>
                    }
                    @if (ordenes[rowIndex].tipo === 'MOVIL') {
                      <div>
                        <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
                      </div>
                    }
                  </td>
                  <td>{{dt.responsable}} </td>
                  <td>
                    <div ngbDropdown container="body">
                      <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">
                        <i class="fe fe-settings"></i>
                      </button>
                      <div class="tx-13" ngbDropdownMenu>
                        <a ngbDropdownItem href="javascript:;" (click)="subirImagenes(ordenes[rowIndex].COD_ORD)" >
                          <i class="far fa-file-image text-primary" aria-hidden="true"></i> <b>&nbsp;&nbsp;AÑADIR NUEVAS IMÁGENES</b>
                        </a>
                        <!-- <a ngbDropdownItem href="javascript:;" >
                        <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;REENVIAR IMAGENES PACIENTE</b>
                      </a>
                      <a ngbDropdownItem href="javascript:;" >
                        <i class="zmdi zmdi-whatsapp text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;REENVIAR IMAGENES DOCTOR</b>
                      </a>
                      -->
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>





      </div>
    </div>
  </div>
</div>
</div>



<!-- ----------------------------------------------------------------------- -->
<!--                        INGRESAR SECUENCIA FISICA                        -->
<!-- ----------------------------------------------------------------------- -->
<ng-template #mdlIngresarSecuencia let-modal>
  <div class="modal-header">
    <h6 class="modal-title">SECUENCIA FISICA</h6>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="form-row">
      <div class="col-md-12">
        <p>Para las siguiente secuencias, anteponer el numero 15 en caso de tener el valor mencionado en la orden fisica</p>
        <p><b>DESDE: 1117001 HASTA: 112200</b></p>
        <b>INGRESE LA SECUENCIA</b>
        <input type="number" class="form-control"  [(ngModel)]='selected'>
        <hr>
          @if (pacienteSecuencia!='') {
            <p class="text-danger text-justify">Lo sentimos la secuencia que ud digitó ya se encuentra asignada al paciente <b>{{pacienteSecuencia}}</b> del Doctor(a) <b>{{doctorSecuencia}}</b>, por favor comuníquese con el ASESOR <b>{{asesorSencuencia}}</b>.</p>
          }

        </div>

      </div>


      @if (spinnerBooleanAsignarOrden) {
        <div class="text-center">
          <div class="spinner-grow" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <br>
          </div>
        }



      </div>
      <div class="modal-footer">
        <button type="button" class="btn ripple btn-primary" (click)="validarSecuenciaFisica()">CREAR ORDEN</button>
        <button type="button" class="btn ripple btn-secondary"  (click)="modal.dismiss('Cross click')">Cerrar</button>
      </div>
    </ng-template>


    <!-- ----------------------------------------------------------------------- -->
    <!--                        INGRESAR SECUENCIA FISICA                        -->
    <!-- ----------------------------------------------------------------------- -->
    <ng-template #mdlIngresarSecuenciaSF let-modal>
      <div class="modal-header">
        <h6 class="modal-title">SECUENCIA FISICA</h6>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">







        <div class="form-row">
          <div class="col-md-12">
            <b>INGRESE LA SECUENCIA</b>
            <input type="number" class="form-control"  [(ngModel)]='selected'>
            <hr>
              @if (pacienteSecuencia!='') {
                <p class="text-danger text-justify">Lo sentimos la secuencia que ud digitó ya se encuentra asignada al paciente <b>{{pacienteSecuencia}}</b> del Doctor(a) <b>{{doctorSecuencia}}</b>, por favor comuníquese con el ASESOR <b>{{asesorSencuencia}}</b>.</p>
              }

            </div>

          </div>


          @if (spinnerBooleanAsignarOrden) {
            <div class="text-center">
              <div class="spinner-grow" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <br>
              </div>
            }



          </div>
          <div class="modal-footer">
            <button type="button" class="btn ripple btn-primary" (click)="validarSecuenciaFisicaSF()">CREAR ORDEN</button>
            <button type="button" class="btn ripple btn-secondary"  (click)="modal.dismiss('Cross click')">Cerrar</button>
          </div>
        </ng-template>





        <ng-template #mdlSubirOrdenFisica let-modal>
          <div class="modal-header">
            <h6 class="modal-title">SUBIR ORDEN FISICA</h6>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <div class="form-row">
              <div class="col-md-12">

                <input type="file" (change)="ordenFisica($event)"><br><br>
              </div>

            </div>


            @if (spinnerBooleanAsignarOrden) {
              <div class="text-center">
                <div class="spinner-grow" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <br>
                </div>
              }



            </div>
            <div class="modal-footer">
              <button type="button" class="btn ripple btn-primary" (click)="subirOrdenFisica()">GUARDAR</button>
              <button type="button" class="btn ripple btn-secondary"  (click)="modal.dismiss('Cross click')">Cerrar</button>
            </div>
          </ng-template>
